import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@mui/material'
import { Theme } from '@mui/material/styles'
import {storeCookieConsent} from '../Utils/helpers'
import {ThemeType} from '../interfaces'
import {PrimaryButton, SecondaryButton} from './Button'
import {useAppThemeOptions} from '../Utils/hooks'

const useStyles = makeStyles<ThemeType>()((theme: Theme, options: ThemeType) => ({
    dialogSecondaryButton: {
        margin: 0,
        border: 0,
    },
}))

export const CookieConsentDialog = ({cookieConsent, setCookieConsent}: {cookieConsent: string | null, setCookieConsent: (consent: string | null) => void}) => {
    const themeOptions = useAppThemeOptions()
    const { classes } = useStyles(themeOptions)
    const { t } = useTranslation()
    const handleCookieConsent = (value: string) => {
        storeCookieConsent(value)
        setCookieConsent(value)
    }

    return (
        <Dialog
            open={cookieConsent === null}
            onClose={undefined}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t('rootContainer.cookieConsent.title')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('rootContainer.cookieConsent.disclaimer')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <PrimaryButton onClick={() => handleCookieConsent('1')}>
                    {t('rootContainer.cookieConsent.accept')}
                </PrimaryButton>
                <SecondaryButton className={classes.dialogSecondaryButton} onClick={() => handleCookieConsent('0')}>
                    {t('rootContainer.cookieConsent.refuse')}
                </SecondaryButton>
            </DialogActions>
        </Dialog>
    )
}
